const INDEED = 'indeed';
const BOOST = 'boost';
const SPRING = 'spring';
const REACH = 'reach';
const JOVEO = 'joveo';
const TALROO = 'talroo';
const ZIPRECRUITER = 'zip_recruiter';
const POOL = 'pool';

export { BOOST, INDEED, JOVEO, POOL, REACH, SPRING, TALROO, ZIPRECRUITER };
